@if(skeleton){
  <lib-skeleton-loader
    [theme]="{
      'height.px': screen === 'desktop' ? (size === 'small' ? 24 : 32) : (size === 'small' ? 34 : 44),
      'width.px': 76
    }"
  ></lib-skeleton-loader>
} @else {
<button class="flex items-center justify-center disabled:opacity-50 disabled:cursor-default overflow-hidden rounded-[6px] border-1 border-transparent focus-visible:outline focus-visible:outline-ring focus-visible:outline-2 focus-visible:outline-offset-2"
  [attr.id]="id() ? id() : null"
  
  [ngClass]="{
  'bg-primary text-primary-foreground': type === 'primary',
  'text-success-foreground bg-success-fade': type === 'success',
  'bg-secondary !border-border-inverted text-secondary-foreground': type === 'secondary',
  'bg-destructive text-destructive-foreground': type === 'destructive',
  '!border-border-solid': type === 'outline',
  'text-foreground': type === 'ghost' || type === 'ghost-active' || type === 'outline',
  'text-muted-foreground': type === 'ghost-inactive',
  'text-link': type === 'link',
  'bg-warning-fade text-warning-foreground' : type === 'warning',
  'bg-danger-fade text-danger-foreground' : type === 'danger',
  'bg-blue-fade text-blue-foreground' : type === 'info',
  'bg-purple-fade text-purple-foreground': type === 'purple',
  'bg-pink-fade text-pink-foreground': type === 'pink',
  'bg-orange-fade text-orange-foreground': type === 'orange',
  'bg-lime-fade text-lime-foreground': type === 'lime',
  'bg-emerald-fade text-emerald-foreground': type === 'emerald',
  'bg-cyan-fade text-cyan-foreground': type === 'cyan',
  'bg-accent-transparent': type === 'ghost-active',
  'opacity-50': state === 'disabled',
  'hover:opacity-90': type !== 'ghost' && type === 'ghost-inactive' && state === 'default' && !loading(),
  'focus-visible:!border-border-solid': (type === 'ghost' || type === 'ghost-inactive' || type === 'link') && state === 'default' && !loading(),
  'hover:bg-accent-transparent active:bg-accent-transparent': (type === 'ghost' || type === 'ghost-inactive') && state === 'default' && !loading(),
  'active:opacity-80': state === 'default' && !loading(),
  'active:bg-accent-solid': type === 'outline' && state === 'default' && !loading(),
  'h-[24px]': size === 'small' && screen === 'desktop',
  'h-[32px]': size === 'default' && screen === 'desktop',
  'h-[34px]': size === 'small' && screen === 'mobile',
  'h-[44px]': size === 'default' && screen === 'mobile',
  'aspect-square': style === 'squared',
  'w-full': style === 'rectangle',

}" [disabled]="loading() || disabled()"
  [type]="buttonType"
  [class]="customClass"
>
  <div smoothSize [smoothWidth]="true" class="w-fit h-fit whitespace-nowrap flex items-center overflow-hidden" [ngClass]="{
      'content-sm-semibold leading-[20px]': size === 'small',
      'content-semibold leading-[24px]': size === 'default',
      'px-[5px] py-[1px]': size === 'small' && screen === 'desktop',
      'py-[3px]': size === 'default' && screen === 'desktop',
      'px-[17px] py-[6px]': size === 'small' && screen === 'mobile',
      'py-[9px]': size === 'default' && screen === 'mobile',
      'py-[11px]': size === 'large' && screen === 'desktop',
      'py-[17px]': size === 'large' && screen === 'mobile',
      'px-[31px]': (size === 'large' || size === 'default') && screen === 'mobile',
      'px-[9px]': (size === 'large' || size === 'default') && screen === 'desktop',
      '!flex-row-reverse': iconAlign === 'right' && !loading(),
      '!px-[0px]': style === 'squared' || withoutXPadding(),
    }">
    @if (icon && ((iconAlign === 'right' && !loading()) || iconAlign === 'left')) {
      @let size = iconSize || '16px';
      <div class="p-[2px] w-[20px] h-[20px] flex items-center justify-center">
        <i class="fi fi-rr-{{icon}} !leading-[{{size}}] text-[{{size}}] !h-[{{size}}] block"></i>
      </div>
    }

    <div [ngClass]="{
      'mx-[5px]': size === 'small',
      'mx-[7px]': size === 'default' || size === 'large',
      '!mx-[0px]': style === 'squared',
    }" class="max-w-full" lib-truncate-tooltip>
      <ng-content/>
    </div>

    @if (loading()) {
      <lib-spinner [size]="16" [color]="type"></lib-spinner>
    }
  </div>
</button>
}
